import { useState } from 'react';

import { useMutation } from '@redwoodjs/web';

import BorderedCard from 'src/components/BorderedCard/BorderedCard';
import { EditInput } from 'src/components/EditInput';
import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { UPDATE_MERCHANT_APPLICATION_WORLDPAY_PO } from 'src/graphql/mutations/updateMerchantApplicationWorldpayPO.mutation';

type WorldPayPOInputProps = {
    merchantApplicationId: number;
    existingWorldpayPO: string;
};

const WorldPayPOInput = ({ merchantApplicationId, existingWorldpayPO }: WorldPayPOInputProps) => {
    const [worldpayPO, setWorldpayPO] = useState<string>(existingWorldpayPO);
    const [updateMerchantApplicationWorldpayPO, { loading: adding }] = useMutation(
        UPDATE_MERCHANT_APPLICATION_WORLDPAY_PO,
        {
            variables: {
                input: {
                    merchantApplicationId,
                    worldpayPO,
                },
            },
            onError: (error) => {
                showErrorToast(
                    `Error saving WorldPay PO number${error ? ` || ${error.message}` : ''}`
                );
            },
            onCompleted: () => {
                showSuccessToast('Worldpay PO number successfully saved');
            },
        }
    );

    return (
        <BorderedCard
            width="100%"
            justifyContent="start"
            gap="4px"
            height="25%"
            flexDirection="column"
        >
            <EditInput
                title="WorldPay PO Number"
                onChange={(worldpayPO: string) => {
                    return setWorldpayPO(worldpayPO);
                }}
                name="World Pay"
                placeholder={'Enter WorldPay PO Number'}
                onUpdate={updateMerchantApplicationWorldpayPO}
                value={worldpayPO}
            />
        </BorderedCard>
    );
};
export default WorldPayPOInput;
